import root from '../../utils/root';

/**
 * @public
 * Prints the phone number in the attribute `href`.
 *
 * @param {Object} phone - Object with the phone data
 * @return {Object}
 */
export default function printPhoneNumber(phone) {
  root.jQuery('.promo_number').attr('href', `tel:${phone.promo_number}`);
  root.jQuery('.promo_number_formatted').html(phone.promo_number_formatted);
  return phone;
}
